module.exports = __webpack_public_path__ + "img/632.A_dripping_faucet.814707f3.svg";